import { render } from "./_Cadastro.vue?vue&type=template&id=529da4c6"
import script from "./_Cadastro.vue?vue&type=script&lang=ts"
export * from "./_Cadastro.vue?vue&type=script&lang=ts"
script.render = render

export default script